var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { getBlankTaskTemplate, getRequestFromTaskTemplate, getTaskTemplateFromDto, } from "../../shared/domainTypes/task/taskTemplate.type";
import TemplateFormInputs from "./templateFormInputs";
import TaskService from "../../../services/TaskService";
import { getTaskAdminTemplateBasePath } from "../../../src/View/Pages/Admin/Task/TaskTemplate/AdminTaskTemplateRoutes";
import { getXSRF } from "../../../src/Services/Shared/FetchService";
export default class TemplateForm extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            this.setState({ saving: true });
            // Validate Task Template
            const validation = TaskService.validateTaskTemplate(this.state.template, !!this.props.isForTemplateInActionPlan);
            if (!validation.isValid) {
                this.setState({ saving: false });
                if (this.props.onError) {
                    this.props.onError(validation.errorMessage);
                }
                return;
            }
            // Expect SingleResponse<TaskTemplateDto>  This will break otherwise.
            const response = yield fetch("/aviso/taskAdmin/saveTemplate", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    template: getRequestFromTaskTemplate(this.state.template),
                }),
            });
            let data;
            try {
                data = yield response.json();
            }
            catch (error) {
                this.setState({ saving: false });
                console.error(error);
                if (this.props.onError) {
                    this.props.onError("There was an error on the server saving that template");
                }
                return;
            }
            this.setState({ saving: false });
            if (!response.ok) {
                console.error("Got bad response from server", response, data);
                if (data && this.props.onError) {
                    this.props.onError(data.message ? data.message.toString() : this.defaultErrorMessage);
                }
            }
            else if (!data.success) {
                console.error("Got failed SingleResponse:", data);
                if (this.props.onError) {
                    this.props.onError(data.message ? data.message.toString() : this.defaultErrorMessage);
                }
            }
            else {
                let template;
                try {
                    template = getTaskTemplateFromDto(data.data);
                }
                catch (error) {
                    console.error("Could not convert data to template.  Got data", data);
                    if (this.props.onError) {
                        this.props.onError(error ? error.toString() : this.defaultErrorMessage);
                    }
                    return;
                }
                if (this.props.onSave) {
                    this.props.onSave(template);
                }
                this.setState({ template, saved: true, saving: false });
                window.location.href = getTaskAdminTemplateBasePath();
            }
        });
        const stateDefaultValues = {
            saving: false,
            saved: false,
            assignedPeoplePrototypes: [],
        };
        if (!this.props.template) {
            // We need to construct a new TaskTemplate.
            // @ts-expect-error - TS2322 - Type '{ saving: false; saved: false; assignedPeoplePrototypes: readonly []; template: TaskTemplate; }' is not assignable to type 'Readonly<State>'.
            this.state = Object.assign({ template: getBlankTaskTemplate() }, stateDefaultValues);
        }
        else {
            // @ts-expect-error - TS2322 - Type '{ saving: false; saved: false; assignedPeoplePrototypes: readonly []; template: TaskTemplate; }' is not assignable to type 'Readonly<State>'.
            this.state = Object.assign({ template: this.props.template }, stateDefaultValues);
        }
        this.defaultErrorMessage = "Something went wrong.";
    }
    render() {
        let saveButtonValue = "Save";
        if (this.state.saving) {
            saveButtonValue = "Saving";
        }
        else if (this.state.saved) {
            saveButtonValue = "Saved";
        }
        return (_jsxs("form", { onSubmit: this.handleSubmit, children: [_jsx(TemplateFormInputs, { onTemplateChange: (change) => {
                        if (!this.state.saving) {
                            if (this.props.onChange) {
                                this.props.onChange();
                            }
                            this.setState({
                                template: Object.assign(Object.assign({}, this.state.template), change),
                                saved: false,
                            });
                        }
                    }, template: this.state.template, isForTemplateInActionPlan: this.props.isForTemplateInActionPlan }), _jsx("div", { className: "form-group", children: _jsxs("button", { type: "submit", className: "btn btn-primary", disabled: this.state.saved || this.state.saving, children: [_jsx("span", { className: "fa fa-save" }), " " + saveButtonValue] }) })] }));
    }
}
